<template>
  <div class="step-by-step">
    <div v-for="(step, index) in steps" :key="index" class="step-item">
      <div class="step-marker">
        <span class="step-num">{{ index + 1 }}</span>
      </div>
      <div class="step-body" v-html="step" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepByStep',
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
};
</script>
